import React, { useContext, useEffect, useState } from "react";
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button } from "@mui/material";
import Context from "../../../../context/Context";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { QrCodeReader } from "../QrCodeReader";
import Loading from "../../../../components/Loading";
import { PhotoModal } from "../PhotoModal";
import { ImageModal } from "../ImageModal";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getTimeFromDateTimeLocate } from "../../../../utils/DataUtils";
import { WsEvents, useWebsocket } from "../../../../context/hooks/WebSocket";
import language from "../../../../nls/language.json"
import './styles.css';
import { PictureAsPdf } from "@mui/icons-material";
import { Impressao } from "../../../molds/template/Impressao";
import { DateTimeFmt } from "../../../../utils/DataUtils";
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const INITIAL_VALUE = {
  url: null,
  vagaoKey: 0
}

export const WagonApprovedCards = ({
  status,
  time,
  color,
  fornoEtapa,
  statusOut,
  confirmedWagon
}) => {

  const [takePhoto, setTakePhoto] = useState(INITIAL_VALUE)
  const [imageUrl, setImageUrl] = useState(null)

  const {
    selectedCountry,
    loadingFullScreen,
    getConfirmedWagon,
    selectedFurnace,
    loading
    // confirmedWagon
  } = useContext(Context);

  const ws = useWebsocket();

  useEffect(() => {
    let event = "";

    switch (status) {
      case "LIBERADO":
        event = WsEvents.ReleasedWagon;
        break;
      case "ENTRADA":
        event = WsEvents.EntryWagon;
        break;
      case "CURVANDO":
        event = WsEvents.CurvadWagon;
        break;
      case "FINALIZADO":
        event = WsEvents.FinisheddWagon;
        break;
    }

    ws.setHandler(event, 'Released-Wagon', () => getConfirmedWagon(status, selectedFurnace));
  }, [status])

  const relacionarPecasEMoldes = (confirmedWagon) => {
    let resultadoPorVagaoKey = {};
    confirmedWagon.forEach((wagon, index) => {
      wagon.wagon.forEach((wagonItem) => {
        wagon.wagonInfo.isagA_Vagoes_Fornos_Pecas.forEach((isagA_Vagoes_Fornos_Peca) => {
          if (wagonItem.ordem_Serial === isagA_Vagoes_Fornos_Peca.ordem_Serial) {
            const vagaoKey = wagon.wagonInfo.vagao_Key;
            if (!resultadoPorVagaoKey[vagaoKey]) {
              resultadoPorVagaoKey[vagaoKey] = [];
            }
            resultadoPorVagaoKey[vagaoKey].push({
              rack_Buffer: wagonItem.rack_Buffer,
              bomba_A: wagonItem.bomba_A,
              bomba_B: wagonItem.bomba_B,
              bomba_C: wagonItem.bomba_C,
              comb_Nome: wagon.tipoCombinacaoPeca.comb_Nome,
              forno: wagon.tipoCombinacaoPeca.forno,
              image: wagon.wagonInfo.vagao_Image,
              m2_Peca: wagonItem.m2_Peca,
              molde_Codigo: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Codigo,
              molde_Descricao: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Descricao,
              molde_Key: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Key,
              molde_Lote: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_Lote,
              molde_QtdPassagens: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_QtdPassagens,
              molde_QtdPassagensMAX: isagA_Vagoes_Fornos_Peca.isagA_Moldes?.molde_QtdPassagensMAX,
              ordem_Part_Short: wagonItem.ordem_Part_Short,
              ordem_Serial: wagonItem.ordem_Serial,
              ordem_VehCod: wagonItem.ordem_VehCod,
              ordem_VehDesc: wagonItem.ordem_VehDesc,
              status_Molde: isagA_Vagoes_Fornos_Peca.status_Molde,
              status_Peca: isagA_Vagoes_Fornos_Peca.status_Peca,
              subProduto_Desc: wagonItem.subProduto_Desc,
              vagao_Serial: wagon.wagonInfo.vagao_Serial,
              cabine: wagon.wagonInfo.isagA_Vagoes_Fornos_Pecas[0].forno_Cabine,
              cabineHistorico: wagon.wagonInfo.isagA_Vagoes_Fornos_Pecas[0].forno_CabineHistorico,
              ultimoApontamento: wagon.wagonInfo._ts_Mod_Saida
                ? wagon.wagonInfo._ts_Mod_Saida
                : wagon.wagonInfo._ts_Mod_Curvando
                  ? wagon.wagonInfo._ts_Mod_Curvando
                  : wagon.wagonInfo._ts_Mod_Entrada
                    ? wagon.wagonInfo._ts_Mod_Entrada
                    : wagon.wagonInfo._ts_Creat
            });
          }
        });
      });
    });

    const resultado = Object.values(resultadoPorVagaoKey);

    return resultado;
  };

  const nextTime = (time, index, stageTime) => {
    const newDate = new Date(time);
    const minutes = newDate.getMinutes();
    newDate.setMinutes(minutes + (stageTime * index));
    return getTimeFromDateTimeLocate(newDate.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }));
  }

  const handlePrint = async (dataOpen) => {
    const classeImpressao = new Impressao(dataOpen);
    const documento = await classeImpressao.PreparaDocumento();
    pdfMake.createPdf(documento).open({}, window.open('', '_blank'));
  }

  const handleCreatePdf = (arrData, data) => {
    const result = {
      wagon: {
        vagao_Serial: data.vagao_Serial
      },
      typesPiecesCombinations: {
        forno: data.forno,
        comb_Nome: data.comb_Nome
      },
      moldsWagon: arrData.map(item => {
        return {
          mold: {
            molde_Codigo: item.molde_Codigo,
            molde_Descricao: item.molde_Descricao,
            molde_Lote: item.molde_Lote,
          },
          piece: {
            bomba_A: item.bomba_A,
            bomba_B: item.bomba_B,
            bomba_C: item.bomba_C,
            ordem_Part_Short: item.ordem_Part_Short,
            ordem_Serial: item.ordem_Serial,
            ordem_VehCod: item.ordem_VehCod,
            ordem_VehDesc: item.ordem_VehDesc,
            subProduto_Desc: item.subProduto_Desc,
          }
        }
      })
    }

    return result;
  }

  const getIcon = (qtdPassagens, qtdPassagensMax) => {
    if (qtdPassagens >= qtdPassagensMax) {
      return <ErrorIcon className="red-icon" />;
    } else if (qtdPassagensMax - qtdPassagens <= 1) {
      return <WarningIcon className="yellow-icon" />;
    }
  };

  return (
    <>
      {!loading ?
        <div>
          {relacionarPecasEMoldes(confirmedWagon).map((vagaoItens, vagaoKey) => (
            <Accordion key={`resultadoRelacionado-${vagaoKey}`}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div className="d-flex">
                  <p className="serial" > {vagaoItens[0].vagao_Serial} </p>
                  <p className="nome" > {vagaoItens[0].comb_Nome} </p>
                  <p className="forno"> {vagaoItens[0].forno} </p>
                  <p className="cabine">Cabine {vagaoItens[0].cabineHistorico} </p>
                  <p className="ultimoApontamento"> Último Apontamento: {DateTimeFmt(vagaoItens[0].ultimoApontamento)}</p>
                  <>
                    {vagaoItens.find((item) => item.status_Peca === "ANALISE") ? <p>Análise</p> : ""}
                  </>
                  <>
                    {time && (
                      <p className={`time`}> {`${statusOut[status]}: ${nextTime(time, vagaoKey, fornoEtapa)}`} </p>
                    )}
                  </>
                </div>
              </AccordionSummary>
              <AccordionDetails className="d-flex justify-content-center p-0">
                <div className="table-fixed">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Ordem Serial</th>
                        <th>Ordem Part Short</th>
                        <th>SubProduto Desc</th>
                        <th>Ordem VehDesc</th>
                        <th>M2 Peca</th>
                        <th>Molde Codigo</th>
                        <th>Molde Descricao</th>
                        <th>Rack Buffer</th>
                        <th>Molde QtdPassagens</th>
                        <th>Molde QtdPassagensMAX</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vagaoItens.map((item, itemkey) => (
                        <tr key={`vagaoItens-${itemkey}`}>
                          <td>{item.ordem_Serial}</td>
                          <td>{item.ordem_Part_Short}</td>
                          <td>{item.subProduto_Desc}</td>
                          <td>{item.ordem_VehDesc}</td>
                          <td>{item.m2_Peca}</td>
                          <td>{item.molde_Codigo}</td>
                          <td>{item.molde_Descricao}</td>
                          <td>{item.rack_Buffer}</td>
                          <td className="icon-cell">
                            {item.molde_QtdPassagens}
                            {getIcon(item.molde_QtdPassagens, item.molde_QtdPassagensMAX)}
                          </td>
                          <td>{item.molde_QtdPassagensMAX}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </AccordionDetails>
              <AccordionActions
                className="d-flex flex-row justify-content-between"
              >
                <Button
                  className="mb-2"
                  onClick={() => handlePrint(handleCreatePdf(vagaoItens, vagaoItens[0]))}
                >
                  <PictureAsPdf className="p-0" />
                </Button>
                <div className="d-flex flex-row">
                  <QrCodeReader
                    vagao_Serial={vagaoItens[0].vagao_Serial}
                    status={status}
                    vagaoItens={vagaoItens}
                    takePhoto={takePhoto}
                    setTakePhoto={setTakePhoto}
                    setImageUrl={setImageUrl}
                    imageUrl={imageUrl}
                  />
                  <PhotoModal
                    vagao_Serial={vagaoItens[0].vagao_Serial}
                    status={status}
                    setTakePhoto={setTakePhoto}
                    takePhoto={takePhoto}
                    setImageUrl={setImageUrl}
                    imageUrl={imageUrl}
                  />


                  {vagaoItens?.length > 0 && vagaoItens[0].image && (

                    <ImageModal
                    vagaoItens={vagaoItens}
                    status={status}
                    />)
                    
                  }

                  

                </div>
              </AccordionActions>

            </Accordion >
          ))}
        </div>
        : <Loading />}
    </>
  );
}